import { useState } from 'react';
import css from './index.module.scss';
import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EFVideoModal from '@/components/UI/EFVideoModal';

const E: React.FC = () => {
    const { t: s } = useLang('business.E');
    const [youtube, setYoutube] = useState('');
    const list = [
        {
            title: s('title_1'),
            desc: s('desc_1'),
        },
        {
            videoPc: 'https://www.youtube.com/embed/_PhbQ5DAgYo?si=ypROgzlC_cu0Gbq_',
            videoH5: 'https://www.youtube.com/embed/_PhbQ5DAgYo?si=ypROgzlC_cu0Gbq_',
            posterPC: 'https://websiteoss.ecoflow.com/upload/image/1766384023601/video.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/upload/image/1766384023587/video%20mob.jpg',
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766384084723/logo%201.png',
            text: s('text_1'),
            name: s('name_1'),
            call: s('call_1'),
        },
        {
            logo: 'https://websiteoss.ecoflow.com/upload/image/1766384088132/logo%202.png',
            text: s('text_2'),
            name: s('name_2'),
            call: s('call_2'),
        },
    ];

    return (
        <section
            className={`${css.section} ${s('title_1')}-business-E GtmModuleData-section`}
            id={`${s('title_1')}-business-E`}
            data-section-id={`${s('title_1')}-business-E`}
            data-section-title={`${s('title_1')}-business-E`}
        >
            {/* <EcoSpace /> */}
            <div className={`info`}>
                {list.map((item, index) => {
                    return <div className={`info-${index + 1} info-item`}>
                        {item.title && <div className="title">{item.title}</div>}
                        {item.desc && <div className="desc">{item.desc}</div>}
                        {item.videoPc && <div className='eco-video' onClick={() => {
                            setYoutube(item.videoPc);
                        }}>
                            <EcoImg className="swiper-item-img" pc={'https://websiteoss.ecoflow.com/upload/image/1766384023601/video.jpg'} />

                            <div className="eco-video-icon">
                                <EcoImg pc={'https://websiteoss.ecoflow.com/upload/image/1767078943408/play.svg'} />

                            </div>
                        </div>}
                        {item.logo && <div className="logo">
                            <EcoImg pc={item.logo} />
                        </div>}
                        {item.text && <div className="text"> {item.text}</div>}
                        {item.name && <div className="name">{item.name}</div>}
                        {item.call && <div className="call"> {item.call}</div>}
                    </div>
                })}

            </div>
            <EFVideoModal visible={Boolean(youtube)} source={youtube} onClose={() => setYoutube('')} playerType={'YouTube'} />
        </section>
    );
};

export default E;
